import { Markdown } from '../../Markdown';
import { messageDir } from '../../../lib/message-direction';
import { ScrollArea } from '../ui';
import styles from './DocViewerModal.module.css';

// A markdown report inside the doc viewer: a centred reading column that scrolls within the modal body.
//
// `variant="chat"` is MANDATORY, not a style preference — `Markdown` only applies remark-gfm for the
// chat variant, so the default `compact` would dump raw `|` pipe tables and `~~strikethrough~~` into a
// report, and reports are full of tables.
//
// DIRECTION IS DECIDED ONCE, FOR THE WHOLE DOCUMENT. `Markdown`'s chat default is `dir="auto"`, which the
// browser resolves per BLOCK ELEMENT from its first strong character — so a mostly-Hebrew report rendered
// as a ragged mix: the Hebrew paragraphs RTL, and every line that happened to open with a Latin word
// (`Status:`, `Subject:`, an `[INSTALMENT AMOUNTS — CONFIRM…]` blockquote) LTR, ~15 independent guesses in
// one document. A report is ONE settled text, so it takes ONE base direction from the majority-script
// verdict (`messageDir` — the 1:1 mirror of iOS `messageIsRTL` / Android `messageIsRtl`), and its English
// fragments embed as LTR runs inside it. `Markdown`'s own `auto` default is deliberately left alone: a
// chat transcript is many short independent messages, each entitled to its own base direction.
//
// The scroll box is `<ScrollArea>`, never a hand-rolled scroll container — see CLAUDE.md
// "Scrollbars"; a report is the longest thing this app scrolls, so it should wear the designed bar.
export function MarkdownDocView({ text }: { text: string }) {
  const dir = messageDir(text);
  return (
    <ScrollArea className={styles.markdownScroll}>
      {/* The dir lives on the column AND is handed to `Markdown`: the column sets the base direction for
          the reading surface, and the prop is what stops `Markdown` re-guessing it per block. */}
      <div className={styles.markdownColumn} dir={dir}>
        <Markdown variant="chat" dir={dir}>
          {text}
        </Markdown>
      </div>
    </ScrollArea>
  );
}
